import React from "react";
import Login from "../components/Login";

export default function LoginPage() {
    return (
      <React.Fragment>
        <Login/>
      </React.Fragment>
    );
  }